import type { PropsWithChildren, ReactNode } from 'react'
import { useIntl } from 'react-intl'

export const MenuLocaleRestricted = ({
  locale: requiredLocale,
  children,
}: PropsWithChildren<{ locale: string }>): ReactNode => {
  const { locale } = useIntl()
  if (locale === requiredLocale) {
    return children
  }
  return null
}
